export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selectedItem: {
      type: Array,
      default: () => []
    },
    isSpread: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    },
    emptyText: {
      type: String,
      default: ''
    }
  },
  computed: {
    style() {
      return {
        height: this.height + 'px',
        width: this.width + 'px'
      };
    }
  },

  methods: {
    isActive(value) {
      return this.selectedItem.some(item => item === value);
    },
    onSelected(item) {
      this.$emit('change', item);
    }
  }
};
